
<template>
  <div class="challenge-container">
    <div class="outbox lecture" v-if="!complete">
      <div class="challenge-header">
        <div class="title">{{ challengeData.tasp_title }}</div>
        <div class="introduction" v-html="challengeData.tasp_content"></div>
      </div>
    
      <div class="challenge-content">
         <div class="section-title">{{ $t('请选择') }} </div>
<!--        <div class="section-title">{{ challengeData.dd_question_title }} </div>-->

        <div class="applylist">
          <div class="applyitem" v-for="(item,index) in questions" :key=index
            @click="checkItem(index,item)"
            :class="{'dis': item.is_submit==10 || btndis}">
            <div class="title">{{item.taspq_title}}</div>
            <div class="content">{{item.taspq_notes}}</div>
            <i class="selbtn" 
              :class="{'iconfont icon-duigou ckd': item.checked||item.is_submit==10}"></i>
          </div>
        </div>
      </div>
      
      <div class="action-bar">
        <el-button type="text" v-if="btndis && taspq_type==10" class="submit-btn dis">{{ $t('已申请') }} </el-button>
        <el-button type="text" v-else-if="btndis" class="submit-btn dis">{{ $t('已申请') }} </el-button>
        <el-button type="text" v-else class="submit-btn" v-throttle="2000" @click="submitAnswers">{{ $t('提交申请') }} </el-button>
      </div>
    </div>
    
    <Result v-if="complete" :typeNum="3" :taspq_type="taspq_type" :applyStr="applyStr" :ta_id="ta_id" :tas_id="tas_id" :tasp_id="tasp_id" :continueAction="continueAction"></Result>


  </div>
</template>

<script>
import Result from './components/result.vue';
import { taskDetailList,taskSubmit } from '@/api/challenge';

export default {
  name: 'lecture',
  components: {
    Result
  },
  data() {
    return {
      complete: false,
      challengeData: {
        tasp_title: '',
        tasp_describe: '',
      },
      questions:[],
      applyStr: '',
      btndis: false,
      taspq_type: 0,
    };
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id; // 获取路由参数 活动id
    },
    tas_id() {
      return this.$route.params.tas_id; // 获取路由参数 阶段id
    },
    tasp_id() {
      return this.$route.params.tasp_id; // 获取路由参数 试卷id
    },
  },
	mounted(option){
		this.getData();
	},
  methods: {
    // 初始化获取数据
    async getData() {
      //活动id ta_id
      //阶段id tas_id
      //试卷id tasp_id
      const res = await taskDetailList({
        ta_id: this.ta_id,//358
        tas_id: this.tas_id,//1
        tasp_id: this.tasp_id //21
      });
      if (res.status == 200) {
        if(res.data.status == false){
          this.$message.error(res.data.msg);
          this.btndis = true
          return;
        }
        this.challengeData = res.data.paper;
        this.questions = res.data.question;
        if(this.questions.length==0){
          this.btndis = true
        }else{
          // 判断是否有已提交 按钮置灰
          let len = this.questions.filter(item => item.is_submit==20).length;
          if(len == 0){
            this.btndis = true
          }
          this.taspq_type = this.questions[0].taspq_type;
          if(this.taspq_type==10){
            //taspq_type==10是单选；已经选了一个就禁止再次提交
            let len = this.questions.filter(item => item.is_submit==10).length;
            if(len > 0){
              this.btndis = true
            }

          }
        }
      }
    },
    checkItem(index, item) {
      if(this.taspq_type==10){
        if(this.btndis)return
        // 只能单选
        this.questions.forEach((q, i) => {
          if (i !== index) {
            q.checked = false;
            this.$set(this.questions, i, q);
          }
        });
        item.checked = !item.checked;
        this.$set(this.questions, index, item);
        return
      }
      if (item.is_submit==10){
        // this.$message({
        //   message: '该大讲堂类型已满员',
        //   type: 'warning'
        // });
        return;
      }
      item.checked = !item.checked;
      this.$set(this.questions, index, item)
    },
    
    async submitAnswers() {
      // 检查是否有选中的选项
      const hasSelected = this.questions.some(item => item.checked);
      
      if (!hasSelected) {
        this.$message({
          message: this.$t('请至少选择一个大讲堂类型'),
          type: 'warning'
        });
        return;
      }
      // 获取选中的项目
      const selectedItems = [];
      this.questions.map((item,index) => {
        if(item.checked){
          selectedItems.push({
            taspq_id: item.taspq_id,
            taspq_title: item.taspq_title,
            // value: index
          });
        }
      });
      this.applyStr = selectedItems.map(item => item.taspq_title).join(',');
      let subObj = {
        ta_id: this.challengeData.ta_id,
        tas_id: this.challengeData.tas_id,
        tasp_id: this.challengeData.tasp_id,
        dd_question_type: this.challengeData.dd_question_type,
        data: selectedItems
      }
      
      const loading = this.$loading({
        lock: false,
        text: this.$t('加载中'),
        background: 'rgba(0, 0, 0, 0.1)'
      });
      const res = await taskSubmit(subObj);
      loading.close();
      if(res.status == 200){
        this.$message.success(this.$t('申请成功'));
          this.complete = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }else{
        // this.$message.error(this.$t('提交失败'));
      }
    },
    continueAction(){
      this.complete = false;
      this.getData();
    }
  }
};
</script>
<style lang="scss" scoped>
.outbox{
  min-width: 1200px;
  max-width: 1680px;
  margin: 0 auto 16px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 32px 32px 0;
	&:last-child{
		margin-bottom: 0;
	}
}
.challenge-container {
  width: 100%;
  padding: 80px 120px 20px;
  background: #f9f9f9;
  min-height: 100vh;
  color: #191919;
  .lecture{
    min-height: calc(100vh - 100px);
  }
  .challenge-header {
    margin-bottom: 48px;
    .title {
      font-size: 26px;
			line-height: 30px;
      margin-bottom: 16px;
    }    
    .introduction {
      font-size: 14px;
      line-height: 24px;
			font-weight: 300;
      color: #595959;
    }
  }
  .challenge-content {
    padding-bottom: 0;
    min-height: calc(100vh - 400px);
  }
  
  .section-title {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 14px;
  }

  .applylist{
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 32px;
    .applyitem{
      width: calc(50% - 8px);
      padding: 24px;
      border-radius: 12px;
      margin-right: 16px;
      box-sizing: border-box;
      border: 1px solid #E6E6E6;
      margin-bottom: 16px;
      margin-right: 16px;
      cursor: pointer;
      &:nth-child(2n){
        margin-right: 0;
      }
      .title{
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 8px;
      }
      .content{
        font-size: 16px;
        line-height: 24px;
        color: #707070;
        margin-bottom: 24px;
        overflow: hidden;
        //显示两行
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
      .selbtn{
        display: block;
        width: 14px;
        height: 14px;
        font-size: 12px;
        text-align: center;
        line-height: 12px;
        border-radius: 2px;	
        border: 1px solid #b3b3b3;        
        &.ckd{
          border-color:  #2673E5;
          background: #2673E5;
          color: #fff;
        }
      }
      &.dis{
        cursor: default;
        .selbtn{
          border-color:  #d9d9d9;
          background: #e6e6e6;     
          &.ckd{
            color: #fff;
            background: #c9c9c9;     
          }
        }
      }

    }
  }

  .action-bar {
    text-align: center;
    padding: 24px 0 32px;
		margin: 32px 0 0;
    border-top: 1px dashed rgb(230, 230, 230);
    .submit-btn {
			box-sizing: border-box;
      font-size: 14px;
			border: 1px solid rgb(179, 0, 0);
			border-radius: 20px;
			min-width: 86px;
      padding-left: 12px;
      padding-right: 12px;
			background: rgb(255, 255, 255);
      color: #B30000;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background-color: rgba(179, 0, 0, 0.1);
      }
      &.dis{
        border-color: #d9d9d9;
        color: #707070;
        background: none !important;
        cursor: default;
      }
    }
  }
}
</style>
